export default function useUUID() {
  return {
    createId: () => "gggg" + Math.random(),
  };
}
